import React from 'react';
import { Gender } from '../model/user/UserProfile';
import { EventType } from '../model/event/Event';
import { formatDate, formatDateTimeWithTime } from './DateFormatter';
import { SaleStatus } from '../model/sale/Sale';
import { ProductQuantitiesType } from '../model/sale/Product';
import { TeamRole } from '../model/team/TeamMember';
import { PaymentMethodType } from '../model/sale/PaymentMethod';
import { PublicState } from '../model/Api';

export const isNull = (value: any) => !value || value === 'null';

export const getEmail = (value: any) =>
  !isNull(value) ? <a href={`mailto:${value}`}>{value}</a> : '-';

export const getGender = (value: Gender) => {
  if (isNull(value)) return '-';

  switch (value) {
    case Gender.MALE:
      return 'männlich';
    case Gender.FEMALE:
      return 'weiblich';
    case Gender.UNKNOWN:
      return 'unbekannt';
    case Gender.OTHER:
      return 'divers';
    default:
      return '-';
  }
};

export const getSaleStatus = (value: SaleStatus) => {
  if (isNull(value)) return '-';

  switch (value) {
    case SaleStatus.OPEN:
      return 'Offen';
    case SaleStatus.CLOSED:
      return 'Geschlossen';
    case SaleStatus.SUBMITTED:
      return 'Übermittelt';
    case SaleStatus.CANCELLED:
      return 'Abgebrochen';
    case SaleStatus.PAYED:
      return 'Bezahlt';
    default:
      return '-';
  }
};

export const getEventTyp = (value: EventType) => {
  if (isNull(value)) return '-';

  switch (value) {
    case EventType.ONLINE:
      return 'Online';
    case EventType.PUBLIC:
      return 'Öffentlich';
    case EventType.PRIVATE:
      return 'Privat';
    default:
      return '-';
  }
};

export const getDate = (value: any) => (!isNull(value) ? formatDate(value) : '');

export const getDateTime = (value: any) =>
  !isNull(value) ? formatDateTimeWithTime(value) + ' Uhr' : '';

export const getCurrency = (value: number) =>
  value !== undefined && value !== null
    ? new Intl.NumberFormat('de-DE', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(value)
    : '';

export const getDezimal = (value: number) =>
  value !== undefined && value !== null ? new Intl.NumberFormat('de-DE').format(value) : '';

export const getStatus = (value?: PublicState) => {
  if (isNull(value)) return '-';
  switch (value) {
    case 'IN_PROGRESS':
      return 'in Bearbeitung';
    case 'NOT_PUBLISHED':
      return 'Nicht Veröffentlicht';
    case 'PUBLISHED':
      return 'Veröffentlicht';
    case 'INACTIVE':
      return 'Inaktiv';
    default:
      return value;
  }
};

export const getQuantities = (value?: ProductQuantitiesType) => {
  if (isNull(value)) return '-';
  switch (value) {
    case ProductQuantitiesType.GRAMM:
      return 'Gramm';
    case ProductQuantitiesType.KILOGRAM:
      return 'Kilogramm';
    case ProductQuantitiesType.LITRE:
      return 'Liter';
    case ProductQuantitiesType.PIECE:
      return 'Stück';
    default:
      return 'Sonstige';
  }
};

export const getTeamStatus = (value?: TeamRole) => {
  if (isNull(value)) return '-';
  switch (value) {
    case TeamRole.BOARD_MEMBER:
      return 'Vorsitzender';
    case TeamRole.TREASURER:
      return 'Kassenwart';
    case TeamRole.SECRETARY:
      return 'Schriftführer';
    case TeamRole.OTHER:
      return 'Funktionär';
    default:
      return 'Sonstige';
  }
};

export const getTeamStatusPlural = (value?: TeamRole) => {
  if (isNull(value)) return '-';
  switch (value) {
    case TeamRole.BOARD_MEMBER:
      return 'Unsere Vorsitzenden';
    case TeamRole.SECRETARY:
      return 'Unsere Kassenwärte';
    case TeamRole.TREASURER:
      return 'Unsere Schriftführer';
    case TeamRole.OTHER:
      return 'Unsere Funktionäre';
    default:
      return 'Sonstige';
  }
};

export const getPaymentMethod = (value?: PaymentMethodType) => {
  if (isNull(value)) return '-';
  switch (value) {
    case PaymentMethodType.CASH:
      return 'Bar';
    case PaymentMethodType.INVOICE:
      return 'Rechnung';
    case PaymentMethodType.TAB:
      return 'Deckel';
    case PaymentMethodType.PAYMENT_SERVICE:
      return 'Zahlungsdienstleister';
    default:
      return 'Sonstige';
  }
};

export const getSaleStatusColor = (status: SaleStatus) => {
  switch (status) {
    case SaleStatus.CLOSED:
      return 'primary';
    case SaleStatus.PAYED:
      return 'success';
    case SaleStatus.OPEN:
      return 'secondary';
    case SaleStatus.SUBMITTED:
      return 'info';
    case SaleStatus.CANCELLED:
      return 'error';
    default:
      return 'default';
  }
};
